export default "__VITE_ASSET__B2r2Ypdx__"